import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

const flexColumn: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
};

export const row: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};

export const titleWrapper: SxStyleFunc = (loading) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  opacity: loading ? 0.5 : 1,
});

export const title: SxStyle = {
  color: (p) => p.palette.common.black,
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const action: SxStyle = {
  color: (p) => p.palette.primary[500],
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const header: SxStyle = {
  ...flexColumn,
  background: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(1.5),
  gap: (p) => p.spacing(1.5),
};

export const headerRow: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const content: SxStyleFunc = (loading) => ({
  ...flexColumn,
  p: (p) => p.spacing(1.5),
  gap: (p) => p.spacing(1),
  maxHeight: 'fit-content',
  minWidth: (p) => p.spacing(56),
  pointerEvents: loading ? 'none' : 'auto',
  opacity: loading ? 0.5 : 1,
});

export const popoverTitle: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  color: (p) => p.palette.common.black,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const grid: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1.5),
  padding: (p) => p.spacing(1.5),
  borderRadius: (p) => p.spacing(1),
  backgroundColor: (p) => p.palette.grey[200],
};
